import React from "react"
import { NextSeo, FAQPageJsonLd } from "next-seo"
import { useRouter } from "next/router"
import Head from "next/head"
import useInject from "~/hooks/useInject"
import Spacer from "~/components/Spacer"
import Markdown from "~/components/Markdown"
import Layout from "~/components/Pages/Basic"
import {
  CATEGORIES_LABELS,
  getCategoryFromUrl,
  getFAQItemsByCategory,
} from "~/components/faq/constants"
import Center from "~/components/basic/Center"
import Accordion from "~/components/faq/Accordion"
import Categories from "~/components/faq/Categories"

const mapStore = (store) => ({
  currentHost: store.ui.currentHost,
})

const FAQItem = () => {
  const { currentHost } = useInject(mapStore)

  const router = useRouter()
  const category = getCategoryFromUrl(router.query.category)
  const items = getFAQItemsByCategory(category)
  if (!category && process.browser) router.replace("/faq")

  let canonicalLink = `${currentHost}/faq/`
  if (router.query.category) {
    canonicalLink += router.query.category
  }

  return (
    <>
      <Head>
        <link rel="canonical" href={canonicalLink} />
      </Head>
      <NextSeo
        title={`${category ? CATEGORIES_LABELS[category] : ""} FAQ | WinIt`}
        description="Get answers to common questions about WinIt, parking ticket disputes, traffic ticket management, and more."
      />
      <Layout>
        {category ? (
          <>
            <FAQPageJsonLd
              mainEntity={items.map((item) => ({
                questionName: item.question,
                acceptedAnswerText: item.answer,
              }))}
            />
            <Categories active={category} />
            <Center>
              <h1>{CATEGORIES_LABELS[category]}</h1>
              <p>All the answers to your questions.</p>
            </Center>
            <Accordion
              open={
                router &&
                router.query &&
                router.query.slug &&
                router.query.slug.length
                  ? router.query.slug[0]
                  : undefined
              }
              items={items.map((item) => [
                item.question,
                <Markdown src={item.answer} />,
              ])}
            />
          </>
        ) : (
          <>
            <h1>This page does not exist...</h1>
          </>
        )}
        <Spacer mobile={50} desktop={70} />
      </Layout>
    </>
  )
}

export default FAQItem
